export default __webpack_public_path__ + "sounds/Explosion-eee33ad380808db365de1e7a49c71c2b.wav";